import {
  collectNodeSourceOptions,
  NodeSourceOption,
} from '../../networkNodeCopyUtils';
import {
  createDefaultShift,
  NetworkNodeFieldPath,
  NetworkNodeFormValues,
  ShiftFormValues,
} from '../../../types';

export type ShiftSourceOption = NodeSourceOption;

export const isFilledShift = (s: ShiftFormValues) =>
  Boolean(s.name?.trim() && s.from?.trim() && s.to?.trim());

const getFilledShifts = (shifts: ShiftFormValues[] = []) =>
  shifts.filter(isFilledShift);

export function collectShiftSourceOptions(
  network: NetworkNodeFormValues[],
  currentPath: NetworkNodeFieldPath,
): ShiftSourceOption[] {
  return collectNodeSourceOptions(
    network,
    currentPath,
    node => node.shifts ?? [],
    items => getFilledShifts(items).length > 0,
  );
}

export function cloneShiftsFromSource(
  source: ShiftFormValues[],
): ShiftFormValues[] {
  return getFilledShifts(source).map(s =>
    createDefaultShift({
      name: s.name,
      from: s.from,
      to: s.to,
    }),
  );
}
